






















































































import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/ServiceRequestModal.scss';
import { MedTransGoConstants } from '../../util/constants';
import { ServiceRequestModel } from '../../types/request';
import { ObjectFactory } from '../../config/objectFactory';
import { CommonUtils } from '../../util/commonUtils';
import { DateUtils } from '@/util/dateUtils';
@Component({
    data() {
        return {
            modalShow: true,
        };
    },
})
export default class ServiceRequestModal extends Vue {

    private member = ObjectFactory.getCacheService().getMemberInfo();
    private canSubmitRequest = true;
    private blockedReason = '';
    private patient: any;
    private serviceRequestObj: ServiceRequestModel = {
        appointments: [{
            date: '',
            time: '',
            timezone: ObjectFactory.getCacheService().getMemberInfo().timezone || DateUtils.getLocalTimezone(),
        }],
        service: {
            additionalService: '' as any,
            type: undefined as any,
            selectedType: undefined as any,
        },
        transportation: {
            conciergeService: undefined as any,
            isOxygenTankRequired: undefined as any,
            mentalHealth: undefined as any,
            caregiver: undefined as any,
            rideshareService: undefined as any,
            isBariatricServiceRequired: undefined as any,
            isWheelchairProvided: undefined as any,
            vehicleType: undefined as any,
            driverGenderPreference: '' as any,
            homeAssistance: undefined as any,
            isUsingHealthInsurance: false,
            estimatedVisitTime: {
                hours: 0,
                minutes: 0,
            },
            visitType: undefined as any,
            attorneyName: '',
            attorneyEmail: '',
            attorneyFirmName: '',
            attorneyPhoneNo: '',
            isImmediateTransportation: undefined as any,
            rxStop: {
                    rxStopName: '',
                    rxAddress: {
                        fullAddress: '',
                        state: '',
                        city: '',
                        zip: '',
                    },
                },
        },
        homeAssistance: {
            estimatedVisitTime: {
                hours: 1,
                minutes: 0,
            },
            appointmentTime: '',
            appointmentDate: '',
            address: {
                fullAddress: '',
            },
        },
        homeHealthCare: {
            estimatedVisitTime: {
                hours: 1,
                minutes: 0,
            },
            address: {
                fullAddress: '',
            },
            serviceType: '',
        },
        interpretation: {
            estimatedTime: {
                hours: 1,
                minutes: 0,
            },
            isMedicalInterpretation: undefined as any,
            isImmediateInterpretation: undefined as any,
            language: '',
            serviceType: undefined as any,
        },
        telemedicine: {
            interpreterRequired: undefined as any,
            description: '',
            participantEmail: '',
            participants: [],
        },
        delivery: {
            route: { pickupAddress: {} as any, dropoffAddress: {} as any },
            businessCloseTime: '',
            deliveryItems: [],
            confirmationMode: undefined as any,
            isCmr: undefined as any,
            additionalIdentifiers: undefined as any,
        },
        cmr: {
            healthInsuranceName: undefined as any,
            patientSecPhone: undefined as any,
        },
        patient: {
            customerServiceNumber: '',
            firstName: '',
            lastName: '',
            fullName: '',
            email: '',
            phone: '',
            address: {
                fullAddress: '',
                longitude: '' as any,
                latitude: '' as any,
            },
            primaryHealthInsuranceName: '',
            primaryHealthInsuranceNumber: '',
            secondaryHealthInsuranceName: '',
            secondaryHealthInsuranceNumber: '',
            patientHeight: {
                feet: '' as any,
                inch: '' as any,
            },
            preferredLanguage: '' as any,
        },
        facility: {
            name: '',
            email: '',
            phone: '',
            address: {
                fullAddress: '',
                longitude: '' as any,
                latitude: '' as any,
            },
        },
        coordinator: {
            name: '',
            email: '',
            phone: '',
        },
        pickupAddress: {
            fullAddress: '',
        },
        roundTrip: undefined as any,
        multipleAppointment: false,
        dropoffAddress: {
            fullAddress: '',
        },
        billingLocationId: '',
        additionalNotes: '',
        rxAdditionalNotes: '',
        appointmentTime: '',
        appointmentDate: '',
        stops: {
            isStop1Valid: false,
            isStop2Valid: false,
            isStop3Valid: false,
        },
        dropoffSameAsBussinessAddress: false,
        dropoffSameAsPatientAddress: false,
        pickupSameAsPatientAddress: false,
        pickupSameAsBussinessAddress: false,
        sameAsTransportAddress: true,
        followTransportRequest: true,
        preferredProviderRequired: undefined as any,
        preferredProvider: '' as any,
        isHealthcareCoordinates: false,
        isPatientCoordinates: false,
        additionalContacts: [],
    };

    public mounted() {
        if (this.$route.query.patientId && this.$route.query.patientId) {
            this.getPatientDetails(this.$route.query.patientId);
        }
        if (this.$route.path === MedTransGoConstants.URL_NEW_SERVICE_REQUEST) {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
            return;
        }
        if (this.member.organization && this.member.organization.status !== 'ACTIVE') {
            this.canSubmitRequest = false;
            this.blockedReason = 'Your organization is no longer active. Please contact your administrator.';
        }
        if (this.member.subscriptionPlan === 'TELEMEDICINE') {
            this.serviceRequestObj.service.selectedType = 'Telemedicine';
            this.serviceRequestObj.service.type = 'Telemedicine';
        }
    }

    private async getPatientDetails(patientId: any) {
        const response = await ObjectFactory.getPatientService().getPatientDetails(this.$store.state.serverUrl,
        patientId);
        if (response.success) {
            this.patient = response.data;
            this.serviceRequestObj.patient.address = this.patient.address;
            this.serviceRequestObj.patient.fullName = this.patient.fullName;
            if (this.patient.fullName !== undefined) {
                const space = this.patient.fullName.indexOf(' ');
                this.serviceRequestObj.patient.firstName = this.patient.fullName.substring(0, space);
                this.serviceRequestObj.patient.lastName = this.patient.fullName.substring(space + 1);
            }
            this.serviceRequestObj.patient.email = this.patient.email;
            this.serviceRequestObj.patient.phone = this.patient.phone;
            this.serviceRequestObj.pickupAddress = this.patient.requestPreference.transportRequest.pickupAddress;
            this.serviceRequestObj.dropoffAddress = this.patient.requestPreference.transportRequest.dropoffAddress;
        } else {
            CommonUtils.showError(response);
        }
    }

    private closeModal() {
        if (this.patient) {
            this.$router.push({
                name: MedTransGoConstants.VIEW_USERS_NAME,
                query: {userType: 'patient'},
            });
        } else {
            const id = this.$route.params.id;
            if (id) {
                this.$router.push({ path: MedTransGoConstants.URL_REQUESTS + '/' + id, query: this.$route.query});
            } else {
                this.$router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME, query: this.$route.query });
            }
        }
    }

}
